export enum EDomainName {
	common = "common",
	contacts = "contacts",
	conversations = "conversations",
	calendars = "calendars"
}